import styled, {css} from "styled-components";

interface IPrizeBoxProps {
    pegIndex: number;
    totalPegs: number;
    fontSize: string;
    highlightPrize: boolean;
}

export const PrizeDefaultBox = styled.div<IPrizeBoxProps>`
    /** create a positioning context for the little peg inside */
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    width: 100%;
    height: 100%;
    /** TODO: WheelOfJackpotbet: Explain this formula in a comment */
    /** The minus here is important because the rotation of the objects are clockwise */
    transform: rotate(${(props) => (-1)*(props.pegIndex)*(360/props.totalPegs)}deg);

    /* TODO: WheelOfJackpotbet: Colors */
    color: ${props => props.highlightPrize ? "#5000B7" : "#6B3E00"};
    font-size: ${props => props.fontSize};
    font-weight: 900;

    ${props => props.highlightPrize ? css`
        background: linear-gradient(175deg,rgb(71, 255, 80) 3.9%,rgb(34, 183, 0) 95.98%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    ` : null};
`;
